import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpEventType } from '@angular/common/http';
import { DestaqueSemanaService, DestaqueSemanaDto } from './destaque-semana.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-destaque-semana-form',
  templateUrl: './destaque-semana-form.component.html',
  styleUrls: ['./destaque-semana-form.component.css']
})
export class DestaqueSemanaFormComponent implements OnInit {
  loading = false;
  saving = false;
  id: string | null = null;

  fornecedorSlug = '';
  dataInicial = '';
  dataFinal = '';
  isActive = true;
  imageUrl = '';

  selectedFile: File | null = null;
  uploadProgress = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private svc: DestaqueSemanaService,
    private notify: NotificationService
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id) {
      this.load();
    }
  }

  load(): void {
    if (!this.id) return;
    this.loading = true;
    this.svc.getById(this.id).subscribe({
      next: (d: DestaqueSemanaDto) => {
        this.fornecedorSlug = d.fornecedorSlug;
        this.dataInicial = d.dataInicial ? d.dataInicial.substring(0, 10) : '';
        this.dataFinal = d.dataFinal ? d.dataFinal.substring(0, 10) : '';
        this.isActive = d.isActive;
        this.imageUrl = d.imageUrl || '';
        this.loading = false;
      },
      error: (err) => {
        console.error('[DestaqueSemana] erro ao carregar', err);
        this.notify.showError('Erro ao carregar destaque da semana');
        this.loading = false;
      }
    });
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files?.[0];
    if (!file) return;
    this.selectedFile = file;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imageUrl = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  save(): void {
    if (!this.fornecedorSlug || !this.dataInicial || !this.dataFinal) {
      this.notify.showError('Preencha todos os campos obrigatórios');
      return;
    }
    if (!this.id && !this.selectedFile) {
      this.notify.showError('Uma imagem é obrigatória ao criar um novo destaque');
      return;
    }

    this.saving = true;
    this.uploadProgress = 0;

    if (this.id) {
      this.saveEdit();
    } else {
      this.saveCreate();
    }
  }

  private saveCreate(): void {
    const fd = new FormData();
    fd.append('image', this.selectedFile as File);
    fd.append('fornecedorSlug', this.fornecedorSlug);
    fd.append('dataInicial', this.dataInicial);
    fd.append('dataFinal', this.dataFinal);
    fd.append('isActive', String(this.isActive));

    this.svc.create(fd).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round((100 * event.loaded) / (event.total || event.loaded));
        } else if (event.type === HttpEventType.Response) {
          this.notify.showSuccess('Destaque da semana criado com sucesso');
          this.router.navigate(['/admin/destaques-semana']);
        }
      },
      error: (err) => {
        console.error('[DestaqueSemana] erro ao criar', err);
        this.notify.showError('Erro ao criar destaque da semana');
        this.saving = false;
        this.uploadProgress = 0;
      }
    });
  }

  private saveEdit(): void {
    const updatePayload: Partial<DestaqueSemanaDto> = {
      fornecedorSlug: this.fornecedorSlug,
      dataInicial: this.dataInicial,
      dataFinal: this.dataFinal,
      isActive: this.isActive
    };

    this.svc.update(this.id!, updatePayload).subscribe({
      next: () => {
        if (this.selectedFile) {
          this.replaceImage();
        } else {
          this.notify.showSuccess('Destaque da semana atualizado');
          this.router.navigate(['/admin/destaques-semana']);
        }
      },
      error: (err) => {
        console.error('[DestaqueSemana] erro ao atualizar', err);
        this.notify.showError('Erro ao atualizar destaque da semana');
        this.saving = false;
      }
    });
  }

  private replaceImage(): void {
    const fd = new FormData();
    fd.append('image', this.selectedFile as File);

    this.svc.updateImage(this.id!, fd).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round((100 * event.loaded) / (event.total || event.loaded));
        } else if (event.type === HttpEventType.Response) {
          this.notify.showSuccess('Destaque da semana atualizado');
          this.router.navigate(['/admin/destaques-semana']);
        }
      },
      error: (err) => {
        console.error('[DestaqueSemana] erro ao substituir imagem', err);
        this.notify.showError('Erro ao substituir imagem');
        this.saving = false;
        this.uploadProgress = 0;
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/admin/destaques-semana']);
  }
}
